/** Shared inline SVG glyphs for HUD + world labels. */
export function iconSvg(kind: string, size = 18): string {
  const common = `class="ico" viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"`;
  switch (kind) {
    case "bag":
      return `<svg ${common}>
        <path d="M7 8h10l-.8 12.2a1.5 1.5 0 0 1-1.5 1.3H9.3a1.5 1.5 0 0 1-1.5-1.3L7 8z"/>
        <path d="M9.2 8V6.2a2.8 2.8 0 0 1 5.6 0V8"/>
        <path d="M7.2 11h9.6"/>
        <circle cx="12" cy="15.5" r="1.2"/>
        <path d="M12 16.7v2"/>
      </svg>`;
    case "bone":
      return `<svg ${common}>
        <path d="M5.2 9.2a2.4 2.4 0 1 1 3.3-3.3L17.8 15.2a2.4 2.4 0 1 1-3.3 3.3z"/>
        <path d="M7.2 7.2l9.6 9.6"/>
        <circle cx="6.2" cy="6.2" r="0.7" fill="currentColor" stroke="none"/>
        <circle cx="17.8" cy="17.8" r="0.7" fill="currentColor" stroke="none"/>
        <path d="M9.5 10.2c.8.3 1.6.7 2.2 1.3"/>
        <path d="M12.2 13.2c.6.6 1.1 1.3 1.4 2"/>
      </svg>`;
    case "paw":
      return `<svg ${common}>
        <ellipse cx="12" cy="17.2" rx="4.2" ry="3.2"/>
        <circle cx="7.2" cy="10.2" r="2.1"/>
        <circle cx="16.8" cy="10.2" r="2.1"/>
        <circle cx="9.2" cy="6.8" r="1.7"/>
        <circle cx="14.8" cy="6.8" r="1.7"/>
        <path d="M10.2 16.2c.6-.7 1.4-1 1.8-1s1.2.3 1.8 1" opacity="0.7"/>
      </svg>`;
    case "run":
      return `<svg ${common}>
        <path d="M5.2 7.2l4.2 4.8-4.2 4.8"/>
        <path d="M11.2 7.2l4.2 4.8-4.2 4.8"/>
        <path d="M17.2 9.5v5"/>
      </svg>`;
    case "portal":
      return `<svg ${common}>
        <ellipse cx="12" cy="12" rx="6.5" ry="9.2"/>
        <ellipse cx="12" cy="12" rx="3.8" ry="6.2" opacity="0.85"/>
        <path d="M12 3.2v17.6"/>
        <path d="M8.4 5.5c1.1 2.2 1.1 10.8 0 13"/>
        <path d="M15.6 5.5c-1.1 2.2-1.1 10.8 0 13"/>
        <circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none"/>
      </svg>`;
    case "hammer":
      return `<svg ${common}>
        <path d="M13.2 4.2l6.2 6.2-2.8 2.8-6.2-6.2z"/>
        <path d="M16.2 7.2l2.2 2.2"/>
        <path d="M11.2 8.4L4.6 19.4a1.1 1.1 0 0 0 1.5 1.5L15 12.4"/>
        <path d="M13.5 5.8l1.8-1.1 3.4 3.4-1.1 1.8"/>
        <path d="M6.2 17.2l1.4 1.4"/>
      </svg>`;
    case "chest":
      return `<svg ${common}>
        <rect x="3.5" y="8" width="17" height="11.5" rx="2"/>
        <path d="M3.5 12.8h17"/>
        <path d="M12 12.8v3.2"/>
        <rect x="10.4" y="14.4" width="3.2" height="2.4" rx="0.5"/>
        <path d="M5.2 8V6.6A2.6 2.6 0 0 1 7.8 4h8.4A2.6 2.6 0 0 1 18.8 6.6V8"/>
        <path d="M7 10.2h2M15 10.2h2" opacity="0.7"/>
      </svg>`;
    case "bank":
      return `<svg ${common}>
        <circle cx="12" cy="12" r="8.2"/>
        <circle cx="12" cy="12" r="6.4" opacity="0.55"/>
        <path d="M12 6.6v10.8"/>
        <path d="M9.2 9.2c.7-1.1 1.7-1.6 2.8-1.6 1.7 0 2.8 1 2.8 2.3 0 1.4-1.1 2.1-2.8 2.4-1.7.3-2.8 1-2.8 2.5 0 1.4 1.2 2.4 3 2.4 1.2 0 2.2-.5 2.9-1.5"/>
      </svg>`;
    case "book":
      return `<svg ${common}>
        <path d="M4.8 5.2h6.2a2.6 2.6 0 0 1 2.6 2.6v11.4H7.6A2.8 2.8 0 0 0 4.8 22z"/>
        <path d="M19.2 5.2h-6.2a2.6 2.6 0 0 0-2.6 2.6v11.4h5.8a2.8 2.8 0 0 1 2.8 2.8z"/>
        <path d="M8.2 9.2h2.6M8.2 12h2.2"/>
        <path d="M13.4 9.2h2.6M13.4 12h2.2"/>
        <path d="M12 7.8v11.4"/>
      </svg>`;
    case "calendar":
      return `<svg ${common}>
        <rect x="3.8" y="5.8" width="16.4" height="14.4" rx="2.2"/>
        <path d="M3.8 10.2h16.4"/>
        <path d="M8 3.8v4M16 3.8v4"/>
        <circle cx="8.2" cy="13.6" r="1" fill="currentColor" stroke="none"/>
        <circle cx="12" cy="13.6" r="1" fill="currentColor" stroke="none"/>
        <circle cx="15.8" cy="13.6" r="1" fill="currentColor" stroke="none"/>
        <circle cx="8.2" cy="17" r="1" fill="currentColor" stroke="none"/>
        <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/>
      </svg>`;
    case "shovel":
      return `<svg ${common}>
        <path d="M12 2.8v11.2"/>
        <path d="M9.2 14h5.6l-1.1 6.4a1.7 1.7 0 0 1-3.4 0z"/>
        <path d="M9.6 4.6h4.8"/>
        <path d="M10.4 6.4h3.2"/>
      </svg>`;
    case "ball":
      return `<svg ${common}>
        <circle cx="12" cy="12" r="8"/>
        <path d="M4.4 10.2h15.2M12 4v16"/>
        <path d="M7.2 6.2c2.2 2.8 7.4 2.8 9.6 0"/>
        <path d="M7.2 17.8c2.2-2.8 7.4-2.8 9.6 0"/>
      </svg>`;
    case "berry":
      return `<svg ${common}>
        <circle cx="10" cy="14.2" r="4"/>
        <circle cx="15.2" cy="12.4" r="3.2"/>
        <circle cx="12.4" cy="10.2" r="2.4"/>
        <path d="M12.2 7.2c0-2 1.8-3.8 3.8-3.8"/>
        <path d="M14.6 5.2c.6 1.2.4 2.4-.2 3.2"/>
      </svg>`;
    case "sit":
      return `<svg ${common}><circle cx="12" cy="7" r="3"/><path d="M7 20c1-5 9-5 10 0"/><path d="M9 14h6"/></svg>`;
    case "sun":
      return `<svg ${common}>
        <circle cx="12" cy="12" r="3.8"/>
        <path d="M12 2.6v2.6M12 18.8v2.6M2.6 12h2.6M18.8 12h2.6"/>
        <path d="M5.2 5.2l1.8 1.8M17 17l1.8 1.8M18.8 5.2l-1.8 1.8M5.2 18.8l1.8-1.8"/>
      </svg>`;
    case "lamp":
      return `<svg ${common}><path d="M9 18h6"/><path d="M10 18v2h4v-2"/><path d="M8 10a4 4 0 1 1 8 0c0 2-1.5 3-2.5 4H10.5C9.5 13 8 12 8 10z"/></svg>`;
    case "flag":
      return `<svg ${common}><path d="M6 3v18"/><path d="M6 4h10l-2 4 2 4H6"/></svg>`;
    case "home":
      return `<svg ${common}><path d="M4 11l8-7 8 7"/><path d="M7 10v9h10v-9"/></svg>`;
    case "star":
      return `<svg ${common}><path d="M12 3l2.2 6.2H21l-5 3.8 1.9 6.2L12 16.4 6.1 19.2 8 13 3 9.2h6.8z"/></svg>`;
    case "heart":
      return `<svg ${common} fill="currentColor" stroke="none">
        <path d="M12 20.4S3.6 14.8 3.6 9.4A4.4 4.4 0 0 1 12 6.2a4.4 4.4 0 0 1 8.4 3.2C20.4 14.8 12 20.4 12 20.4z"/>
      </svg>`;
    case "check":
      return `<svg ${common}><path d="M5 13l5 5L20 6"/></svg>`;
    case "dot":
      return `<svg ${common}><circle cx="12" cy="12" r="3"/></svg>`;
    case "collar":
      return `<svg ${common}>
        <ellipse cx="12" cy="11.5" rx="8" ry="5"/>
        <path d="M7.5 14.5c1.2 2.2 7.8 2.2 9 0"/>
        <circle cx="12" cy="17.2" r="2"/>
        <circle cx="12" cy="17.2" r="0.7" fill="currentColor" stroke="none"/>
      </svg>`;
    case "sparkle":
      return `<svg ${common}>
        <path d="M12 3.2l1.1 4.4 4.4 1.1-4.4 1.1L12 14.2l-1.1-4.4-4.4-1.1 4.4-1.1z"/>
        <path d="M18.2 14.2l.6 2.2 2.2.6-2.2.6-.6 2.2-.6-2.2-2.2-.6 2.2-.6z"/>
        <path d="M5.2 15.2l.5 1.8 1.8.5-1.8.5-.5 1.8-.5-1.8-1.8-.5 1.8-.5z"/>
      </svg>`;
    case "crown":
      return `<svg ${common}>
        <path d="M4.5 16.5h15l-1.2-8.2-3.6 3.2L12 6.2l-2.7 5.3-3.6-3.2z"/>
        <path d="M5 16.5h14v2.2H5z"/>
      </svg>`;
    case "hat":
      return `<svg ${common}>
        <path d="M5 15.5h14"/>
        <path d="M7.2 15.5c0-4.2 2.2-7.2 4.8-7.2s4.8 3 4.8 7.2"/>
        <path d="M9.2 10.2h5.6"/>
      </svg>`;
    case "chain":
      return `<svg ${common}>
        <path d="M8.2 9.2a2.6 2.6 0 0 1 3.7 0l1.2 1.2a2.6 2.6 0 0 1 0 3.7"/>
        <path d="M15.8 14.8a2.6 2.6 0 0 1-3.7 0l-1.2-1.2a2.6 2.6 0 0 1 0-3.7"/>
        <circle cx="12" cy="17.5" r="1.4"/>
      </svg>`;
    case "treat":
      return `<svg ${common}><path d="M8 8c2-3 6-3 8 0s0 8-4 10c-4-2-6-7-4-10z"/></svg>`;
    case "scroll":
      return `<svg ${common}><path d="M7 5h9a2 2 0 0 1 2 2v11H9a2 2 0 0 0-2 2V5z"/><path d="M9 9h6M9 13h4"/></svg>`;
    case "stick":
      return `<svg ${common}><path d="M5 17l12-12"/><path d="M15 5l4 1-1 4"/></svg>`;
    case "ore":
      return `<svg ${common}><path d="M12 4l6 5-2 9H8l-2-9z"/></svg>`;
    case "hotdog":
      return `<svg ${common}><path d="M5 14c2 3 12 3 14 0"/><path d="M6 13c2-2 10-2 12 0"/><path d="M8 12l1 2M12 11l1 2M16 12l1 2"/></svg>`;
    case "cone":
      return `<svg ${common}><path d="M12 4c3 0 4 3 3 5H9c-1-2 0-5 3-5z"/><path d="M9 9l3 11 3-11"/></svg>`;
    case "pretzel":
      return `<svg ${common}><path d="M8 10c0-3 3-4 4-2 1-2 4-1 4 2 0 4-4 6-4 8"/><path d="M12 18c0-2-4-4-4-8"/></svg>`;
    case "popcorn":
      return `<svg ${common}><path d="M8 10h8l-1 10H9z"/><circle cx="10" cy="8" r="2"/><circle cx="14" cy="7" r="2"/><circle cx="12" cy="9" r="1.5"/></svg>`;
    case "balloon":
      return `<svg ${common}><ellipse cx="12" cy="9" rx="5" ry="6"/><path d="M12 15v5M10 20h4"/></svg>`;
    default:
      return `<svg ${common}><circle cx="12" cy="12" r="7"/></svg>`;
  }
}

function shadeHex(hex: string, factor: number): string {
  const raw = hex.replace("#", "");
  if (raw.length !== 6) {
    return hex;
  }
  const n = Number.parseInt(raw, 16);
  const mix = (c: number) => Math.max(0, Math.min(255, Math.round(c * factor)));
  const r = mix((n >> 16) & 255);
  const g = mix((n >> 8) & 255);
  const b = mix(n & 255);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

/** Full-color filled glyphs for bag / bank item slots. */
export function filledItemIcon(kind: string, color: string, size = 22): string {
  const fill = color.startsWith("#") ? color : `#${color}`;
  const edge = shadeHex(fill, 0.55);
  const light = shadeHex(fill, 1.18);
  const leaf = "#5d8a3a";
  const wood = "#8d6e4a";
  const metal = "#9aa3ad";
  const ink = shadeHex(fill, 0.35);
  const base = `class="ico ico-item" viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true"`;
  switch (kind) {
    case "shovel":
      return `<svg ${base}>
        <path d="M12 2.8v10.6" fill="none" stroke="${wood}" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M9.6 4.4h4.8M10.4 6.2h3.2" fill="none" stroke="${wood}" stroke-width="1.4" stroke-linecap="round"/>
        <path d="M9 13.6h6l-1.15 6.6a1.85 1.85 0 0 1-3.7 0z" fill="${metal}" stroke="${edge}" stroke-width="1"/>
      </svg>`;
    case "ball":
      return `<svg ${base}>
        <circle cx="12" cy="12" r="8" fill="${fill}" stroke="${edge}" stroke-width="1.1"/>
        <path d="M4.4 10.2h15.2M12 4v16" fill="none" stroke="${ink}" stroke-width="1.15" opacity="0.55"/>
        <path d="M7.2 6.2c2.2 2.8 7.4 2.8 9.6 0M7.2 17.8c2.2-2.8 7.4-2.8 9.6 0" fill="none" stroke="${light}" stroke-width="1.1" opacity="0.7"/>
      </svg>`;
    case "berry":
      return `<svg ${base}>
        <circle cx="10" cy="14.2" r="4.1" fill="${fill}" stroke="${edge}" stroke-width="1"/>
        <circle cx="15.2" cy="12.4" r="3.3" fill="${light}" stroke="${edge}" stroke-width="1"/>
        <circle cx="12.4" cy="10.1" r="2.5" fill="${shadeHex(fill, 0.88)}" stroke="${edge}" stroke-width="1"/>
        <path d="M12.2 7.1c0-2 1.8-3.7 3.7-3.7" fill="none" stroke="${leaf}" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M14.5 5.1c.55 1.15.35 2.25-.25 3.05" fill="none" stroke="${leaf}" stroke-width="1.3" stroke-linecap="round"/>
      </svg>`;
    case "treat":
      return `<svg ${base}>
        <path d="M8 8c2-3 6-3 8 0s0 8-4 10c-4-2-6-7-4-10z" fill="${fill}" stroke="${edge}" stroke-width="1.1"/>
        <ellipse cx="11.2" cy="10.2" rx="1.1" ry="0.7" fill="${light}" opacity="0.7"/>
      </svg>`;
    case "ore":
      return `<svg ${base}>
        <path d="M12 4l6 5-2 9H8l-2-9z" fill="${fill}" stroke="${edge}" stroke-width="1.1"/>
        <path d="M10.2 8.2l3.2-1.4 1.6 2.6-2.4 1.1z" fill="${light}" opacity="0.55"/>
      </svg>`;
    case "stick":
      return `<svg ${base}>
        <path d="M5.2 17.2l11.6-11.6" fill="none" stroke="${fill}" stroke-width="2.6" stroke-linecap="round"/>
        <path d="M15 5.1l4 1-1 4" fill="none" stroke="${wood}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    case "scroll":
      return `<svg ${base}>
        <path d="M7 5h9a2 2 0 0 1 2 2v11H9a2 2 0 0 0-2 2V5z" fill="${fill}" stroke="${edge}" stroke-width="1.05"/>
        <path d="M9 9h6M9 13h4" fill="none" stroke="${ink}" stroke-width="1.2" stroke-linecap="round"/>
      </svg>`;
    case "collar":
      return `<svg ${base}>
        <ellipse cx="12" cy="11.5" rx="8" ry="5" fill="${fill}" stroke="${edge}" stroke-width="1.1"/>
        <path d="M7.5 14.5c1.2 2.2 7.8 2.2 9 0" fill="none" stroke="${ink}" stroke-width="1.2" opacity="0.45"/>
        <circle cx="12" cy="17.2" r="2.15" fill="${metal}" stroke="${edge}" stroke-width="1"/>
        <circle cx="12" cy="17.2" r="0.7" fill="${ink}"/>
      </svg>`;
    case "bag":
      return `<svg ${base}>
        <path d="M7 8h10l-.8 12.2a1.5 1.5 0 0 1-1.5 1.3H9.3a1.5 1.5 0 0 1-1.5-1.3L7 8z" fill="${fill}" stroke="${edge}" stroke-width="1.05"/>
        <path d="M9.2 8V6.2a2.8 2.8 0 0 1 5.6 0V8" fill="none" stroke="${edge}" stroke-width="1.3"/>
        <path d="M7.2 11h9.6" fill="none" stroke="${ink}" stroke-width="1.1" opacity="0.4"/>
        <circle cx="12" cy="15.5" r="1.35" fill="${metal}"/>
      </svg>`;
    default:
      return `<svg ${base}><circle cx="12" cy="12" r="7" fill="${fill}" stroke="${edge}" stroke-width="1.1"/></svg>`;
  }
}
